import { useMutation } from '@tanstack/react-query';
import apiRequest from '../../services/apiWrapper';
import { PAYMENT_SCHEMES_URL } from '../../utils/constants/urlConstants';

interface UpdateSchemeStatusDto {
  schemeId: string | null;
  status: number;
}

async function updatePaymentSchemeStatus(
  schemeId: string | null,
  status: number
) {
  return apiRequest.patch<Omit<UpdateSchemeStatusDto, 'schemeId'>, void>(
    `${PAYMENT_SCHEMES_URL}/${schemeId}/status`,
    {
      status: status,
    }
  );
}

export function useUpdatePaymentSchemeStatus() {
  return useMutation({
    mutationFn: (payload: UpdateSchemeStatusDto) =>
      updatePaymentSchemeStatus(payload.schemeId, payload.status),
  });
}
